import BaseRepository from "./BaseRepository";

export default new (class PartnerAppRepository extends BaseRepository {
  getConstants() {
    return this.api.get(`/partner_app/constants`).map((response) => response.data);
  }

  getDashboardCounters() {
    return this.api.get(`/partner_app/dashboard_counters`).map((response) => response.data);
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/PartnerAppRepository.js